import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/Navbar.css';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header className={`mem-nav${scrolled ? ' mem-nav--scrolled' : ''}`}>
      <div className="mem-nav__inner">
        <Link to="/" className="mem-nav__logo" onClick={() => setMenuOpen(false)}>
          Market Edge Metrics
        </Link>

        <nav className="mem-nav__links" aria-label="Primary">
          {NAV_LINKS.map(({ label, to }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `mem-nav__link${isActive ? ' mem-nav__link--active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mem-nav__actions">
          <Link to="/dashboard" className="mem-nav__cta">
            Open Dashboard
          </Link>
          <button
            type="button"
            className={`mem-nav__burger${menuOpen ? ' mem-nav__burger--open' : ''}`}
            aria-expanded={menuOpen}
            aria-controls="mem-nav-drawer"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div
        id="mem-nav-drawer"
        className={`mem-nav__drawer${menuOpen ? ' mem-nav__drawer--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <div className="mem-nav__drawer-backdrop" onClick={() => setMenuOpen(false)} aria-hidden />
        <div className="mem-nav__drawer-panel" role="dialog" aria-modal="true" aria-label="Menu">
          {NAV_LINKS.map(({ label, to }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `mem-nav__drawer-link${isActive ? ' mem-nav__drawer-link--active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
          <Link to="/dashboard" className="mem-nav__drawer-cta" onClick={() => setMenuOpen(false)}>
            Open Dashboard
          </Link>
        </div>
      </div>
    </header>
  );
}
